module.exports = __webpack_public_path__ + "img/icon-auth.9c52bfe7.png";